import { ApiChecksEnum } from '@lib/enums';

export class VouchersApiUrlsUtil {
  private static baseUrl = ApiChecksEnum.voucherList;

  /**
   * Связывает участника конкурса с чеком
   *
   * PUT method, allow body:
   * {
   *    comment: string;
   * }
   * @param voucherId Идентификатор чека
   * @param customerId Идентификатор участника
   */
  public static bindCustomer(voucherId: number, customerId: number): string {

    return `${this.baseUrl}/${voucherId}/BindCustomer/${customerId}`;
  }

  /**
   * Добавляет фото чека к чеку.
   *
   * @param voucherId Идентификатор чека
   */
  public static addPhoto(voucherId: number): string {

    return `${this.baseUrl}/${voucherId}/AddPhoto`;
  }
}
